<shared-toolbar title="Asignar Roles a Usuario">
  @if (!isRole) {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <input
        type="text"
        aria-label="text"
        matInput
        [(ngModel)]="selectedBussinesName"
        [formControl]="myControl"
        [disabled]="!ValidBusiness_id()"
        [matAutocomplete]="auto"
        (keydown)="onKeyDown($event)" />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="
          onOptionSelected($event.option.value, $event.option.viewValue)
        "
        (optionSelected)="storebybusiness()">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.idBusiness">{{ option.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  } @else {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <mat-select
        [disabled]="!ValidBusiness_id()"
        (selectionChange)="storebybusiness()"
        [(value)]="selectedBussines">
        @for (item of bussines; track item) {
          <mat-option [value]="item.idBusiness">{{ item.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field subscriptSizing="dynamic" appearance="outline">
    <mat-label>Buscar</mat-label>
    <input
      type="text"
      [(ngModel)]="fielInput"
      placeholder="Buscar roles..."
      (ngModelChange)="buscarUsuarios()"
      appearance="outline"
      #input
      matInput />
    @if (!input.value) {
      <mat-icon matSuffix>search</mat-icon>
    }
  </mat-form-field>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content
    class="overflow-y-hidden overflow-x-scroll gap-4 sm:flex align-items-baseline sm:align-items-center">
    <!-- CARD USERS -->
    <div class="w-full h-full">
      <div>
        <p mat-subheader class="text-2xl">Usuarios</p>
      </div>
      <div class="overflow-auto h-30rem">
        <mat-selection-list
          hideSingleSelectionIndicator="true"
          [multiple]="false">
          @for (user of users; track user) {
            <mat-list-option (click)="setCurrentUser(user)" [value]="users">
              <a
                >{{ user.user_name }}, {{ user.first_name }}
                {{ user.last_name }}</a
              >
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </div>

    <!-- CARD Roles x Usuario -->
    <div class="w-full h-full">
      <div>
        <p mat-subheader class="text-2xl">Roles web</p>
      </div>

      <div>
        <div class="overflow-auto h-28rem">
          @if (currentUser.worker_id === -1) {
            <p>Seleccione un Usuario</p>
          } @else {
            <mat-list>
              @for (val of showList; track val) {
                <mat-list-item>
                  <mat-slide-toggle
                    [matTooltip]="
                      'Descripción: ' +
                      val.role.description +
                      ' Tipo: ' +
                      val.role.type
                    "
                    matTooltipPosition="right"
                    [disabled]="shouldDisableSwitch(val)"
                    color="primary"
                    class="mb-1"
                    (change)="changeState(val)"
                    checked="{{ val.state }}"
                    [(ngModel)]="val.state"
                    >{{ val.role.name }}</mat-slide-toggle
                  >
                </mat-list-item>
              }
            </mat-list>
          }
        </div>
      </div>
    </div>
    <!-- Rol secundario -->
    <div class="w-full h-full">
      <div>
        <p mat-subheader class="text-2xl">Roles móvil</p>
      </div>

      <div>
        <div class="overflow-auto h-28rem">
          @if (currentUser.worker_id === -1) {
            <p>Seleccione un Usuario</p>
          } @else {
            <mat-list>
              @for (val of showListSecondary; track val) {
                <mat-list-item>
                  <mat-slide-toggle
                    [matTooltip]="
                      'Descripción: ' +
                      val.role.description +
                      ' Tipo: ' +
                      val.role.type
                    "
                    matTooltipPosition="right"
                    [disabled]="shouldDisableSwitchSegundary(val)"
                    color="primary"
                    class="mb-1"
                    (change)="changeState(val)"
                    checked="{{ val.state }}"
                    [(ngModel)]="val.state"
                    >{{ val.role.name }}</mat-slide-toggle
                  >
                </mat-list-item>
              }
            </mat-list>
          }
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
